import axios from 'axios'
import * as types from './types'

export default {
  [types.GET_SERIES_TYPES]: ({ commit }) => {
    return axios.get('/common/types/series')
      .then(resp => {
        commit(types.MUTATE_SERIES_TYPES, resp.data)
        return Promise.resolve(resp)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  [types.GET_SERIES_REPETITION_TYPES]: ({ commit }) => {
    return axios.get('/common/types/series_repetitions')
      .then(resp => {
        commit(types.MUTATE_SERIES_REPETITION_TYPES, resp.data)
        return Promise.resolve(resp)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  [types.GET_SERIES_MONTHLY_REPETITION_TYPES]: ({ commit }) => {
    return axios.get('/common/types/series_monthly_repetitions')
      .then(resp => {
        commit(types.MUTATE_SERIES_MONTHLY_REPETITION_TYPES, resp.data)
        return Promise.resolve(resp)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  [types.GET_DUTY_VALUE_SOURCE_TYPES]: ({ commit }) => {
    return axios.get('/common/types/duty_value_sources')
      .then(resp => {
        commit(types.MUTATE_DUTY_VALUE_SOURCE_TYPES, resp.data)
        return Promise.resolve(resp)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  [types.SAVE_SERIES]: (_, payload) => {
    return axios.post('/series', payload)
      .then(resp => {
        return Promise.resolve(resp)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  [types.SEARCH_SERIES]: ({ commit }, payload) => {
    return axios.get('/series', { params: payload })
      .then(resp => {
        commit(types.MUTATE_SERIES_SEARCH_RESULTS, resp.data)
        return Promise.resolve(resp)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  [types.DELETE_SERIES]: (_, payload) => {
    return axios.delete(`/series/${payload}`)
      .then(resp => {
        return Promise.resolve(resp)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  [types.GET_SERIES_BY_ID]: (_, payload) => {
    return axios.get(`/series/${payload}`)
      .then(resp => {
        return Promise.resolve(resp)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }
}
